<template>
  <!-- Page Content -->
  <div class="h-100 d-flex flex-column">
    <div class="row f-row justify-content-center h-100">
      <!-- First Column -->
      <div class="col col-9 text-center" style="height: 100%;">
        <div class="h-100 d-flex flex-column">
          <!-- 2 Charts Column -->
          <div class="row f-row h-100">
            <div class="col col-12" style="height:100%; width:100%">
              <!-- Chart 1 -->
              <div class="container-chart-trends" style="height: 60%;">
                <!-- Row: title -->
                <div
                  class="row f-row markets-chart-title d-flex align-items-center"
                >
                  <slot name="spot"></slot>
                </div>
                <!-- Row: controls and labels -->
                <div
                  class="row f-row mt-2 justify-content-center"
                  style="vertical-align: middle!important; padding: 0 62px 0 5px!important;"
                >
                  <div
                    class="col mr-2"
                    :class="screenWidth < 1200 ? 'col-3' : 'col-2'"
                  >
                    <div
                      class="div-mid-align btn-toolbar"
                      role="toolbar"
                      aria-label="Toolbar with button groups"
                    >
                      <div
                        class="btn-group btn-group-toggle btn-block"
                        role="group"
                      >
                        <button
                          type="button"
                          class="btn btn-candle"
                          v-on:click="_pickedTimeFrame('SHORT')"
                          v-bind:class="[
                            pickedTimeFrame === 'SHORT' ? 'active' : '',
                          ]"
                        >
                          SHORT
                        </button>
                        <button
                          type="button"
                          class="btn btn-candle"
                          v-on:click="_pickedTimeFrame('MEDIUM')"
                          v-bind:class="[
                            pickedTimeFrame === 'MEDIUM' ? 'active' : '',
                          ]"
                        >
                          MEDIUM
                        </button>
                        <button
                          type="button"
                          class="btn btn-candle"
                          v-on:click="_pickedTimeFrame('LONG')"
                          v-bind:class="[
                            pickedTimeFrame === 'LONG' ? 'active' : '',
                          ]"
                        >
                          LONG
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col col-3 ml-2">
                    <div
                      class="div-mid-align btn-toolbar"
                      role="toolbar"
                      aria-label="Toolbar with button groups"
                    >
                      <div
                        class="btn-group btn-group-toggle btn-block"
                        role="group"
                      >
                        <button
                          type="button"
                          class="btn btn-candle"
                          v-on:click="_pickedDate('1Y')"
                          v-bind:class="[pickedDate === '1Y' ? 'active' : '']"
                        >
                          1Y
                        </button>
                        <button
                          type="button"
                          class="btn btn-candle"
                          v-on:click="_pickedDate('2Y')"
                          v-bind:class="[pickedDate === '2Y' ? 'active' : '']"
                        >
                          2Y
                        </button>
                        <button
                          type="button"
                          class="btn btn-candle"
                          v-on:click="_pickedDate('3Y')"
                          v-bind:class="[pickedDate === '3Y' ? 'active' : '']"
                        >
                          3Y
                        </button>
                        <button
                          type="button"
                          class="btn btn-candle"
                          v-on:click="_pickedDate('4Y')"
                          v-bind:class="[pickedDate === '4Y' ? 'active' : '']"
                        >
                          4Y
                        </button>
                        <button
                          type="button"
                          class="btn btn-candle"
                          v-on:click="_pickedDate('5Y')"
                          v-bind:class="[pickedDate === '5Y' ? 'active' : '']"
                        >
                          5Y
                        </button>
                        <button
                          type="button"
                          class="btn btn-candle"
                          v-on:click="_pickedDate('10Y')"
                          v-bind:class="[pickedDate === '10Y' ? 'active' : '']"
                        >
                          10Y
                        </button>
                        <button
                          type="button"
                          class="btn btn-candle"
                          v-on:click="_pickedDate('20Y')"
                          v-bind:class="[pickedDate === '20Y' ? 'active' : '']"
                        >
                          20Y
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col"
                    :class="screenWidth < 1200 ? 'col-2' : 'col-3'"
                  ></div>
                  <div
                    class="col col-cx f-row row-middle-titles"
                    id="trendControls"
                    style="background: var(--background); border: 1px solid var(--lightbackground)"
                  >
                    <table
                      class="table table-sm table-borderless table-data-controls"
                      style="width: 100%;"
                    >
                      <tbody>
                        <tr class="txt-label-primary-5">
                          <td class="txt-label-primary-5">
                            Date:
                          </td>
                          <td class="txt-label-primary-5">
                            Close:
                          </td>
                          <td class="txt-label-primary-5">
                            Trend %:
                          </td>
                        </tr>
                        <tr>
                          <td class="txt-label-primary">
                            <div
                              id="trendDate"
                              class="candle-hover-info text-center"
                            >
                              -
                            </div>
                          </td>
                          <td class="txt-label-primary">
                            <div
                              id="trendClose"
                              class="candle-hover-info text-center"
                            >
                              -
                            </div>
                          </td>
                          <td class="txt-label-primary">
                            <div
                              id="trendChange"
                              class="candle-hover-info text-center"
                            >
                              -
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Row: legend -->
                <div
                  class="row f-row container-legends-trends container-legends-hist"
                >
                  <div class="col col-5 text-left">
                    <table
                      class="table table-sm table-responsive table-borderless table-market-legend"
                      style="background: rgba(0,0,0,0)"
                    >
                      <tbody>
                        <tr>
                          <td class="text-left" style="width:180px;">
                            <div class="triangle-topleft-1"></div>
                            <span class="inline-ul ml-1">UPTREND UP/DOWN</span>
                          </td>
                          <td class="text-left" style="width:180px;">
                            <div class="triangle-topleft-2"></div>
                            <span class="inline-ul ml-1"
                              >DOWNTREND UP/DOWN</span
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Row: Chart -->
                <div class="row f-row h-100">
                  <div
                    class="col col-12 text-center progress-div"
                    v-if="showLoading"
                  >
                    <QSLoading
                      :isLoading="showLoading"
                      :size="35"
                      :colorTheme="colorTheme"
                    />
                  </div>
                  <div
                    class="col col-12 text-center"
                    v-else-if="chartData.length === 0"
                    style="position: absolute; left: 0; top: 27.5%; z-index: 10000000;"
                  >
                    No Data Available
                  </div>
                  <div class="col col-12" style="height:100%; width:100%">
                    <div
                      class="d-flex flex-column"
                      id="trends-div"
                      style="width: 100%; height: 98%;"
                    >
                      <svg id="svg-trends"></svg>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Chart 2 -->
              <div class="container-chart-trends" style="height: 40%;">
                <!-- Row: title -->
                <div class="row f-row">
                  <div class="markets-chart-title col col-12">
                    PERCENTAGE CHANGE (LOGARITHMIC)
                  </div>
                </div>
                <!-- Row: legend -->
                <div class="row f-row container-legends-trends">
                  <div class="col col-5 text-left">
                    <table
                      class="table table-sm table-responsive table-borderless table-market-legend"
                      style="width: 100%; background: rgba(0,0,0,0)"
                    >
                      <tbody>
                        <tr>
                          <td class="text-left" style="width:180px;">
                            <i
                              class="fa fa-minus"
                              style="color: var(--expo)"
                            ></i>
                            <span class="inline-ul ml-1">% CHANGE UPTREND</span>
                          </td>
                          <td class="text-left" style="width:180px;">
                            <i
                              class="fa fa-minus"
                              style="color: var(--graylightbackground)"
                            ></i>
                            <span class="inline-ul ml-1"
                              >% CHANGE DOWNTREND</span
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- Row: Chart -->
                <div class="row f-row h-100">
                  <div
                    class="col col-12 text-center progress-div"
                    v-if="showLoading"
                  >
                    <QSLoading
                      :isLoading="showLoading"
                      :size="35"
                      :colorTheme="colorTheme"
                    />
                  </div>
                  <div
                    class="col col-12 text-center"
                    v-else-if="chartData.length === 0"
                    style="position: absolute; left: 0; top: 77.5%; z-index: 10000000;"
                  >
                    No Data Available
                  </div>
                  <div class="col col-12" style="height:100%; width:100%">
                    <div
                      class="h-100 d-flex flex-column"
                      id="trends_change-div"
                      style="width: 100%; height: 100%"
                    >
                      <svg id="svg-trends_change"></svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ======================== //// ============================== -->
      <!-- Second Column -->
      <div class="col col-3 text-center results-divider" style="height: 100%;">
        <div class="h-100 d-flex flex-column">
          <!-- Row: title and resize button -->
          <div class="row f-row">
            <div
              class="markets-chart-title col col-12 container-title-analysis"
            >
              Market Trend Analysis
            </div>
          </div>
          <!-- Row: Chart -->
          <div class="row f-row h-100">
            <div class="col col-12 text-center progress-div" v-if="showLoading">
              <QSLoading
                :isLoading="showLoading"
                :size="35"
                :colorTheme="colorTheme"
              />
            </div>
            <div
              class="col col-12 text-center"
              v-else-if="chartData.length === 0"
              style="position: absolute; left: 0; top: 45%; z-index: 10000000;"
            >
              No Data Available
            </div>
            <TrendsTable
              :changeDn="changeDn"
              :changeDn90="changeDn90"
              :changeUp="changeUp"
              :changeUp90="changeUp90"
              :colorExpo="colorExpo(colorTheme)"
              :colorDarkRed="lightbackground2(colorTheme)"
              :colorTheme="colorTheme"
              :dnCount="dnCount"
              :dnRets="dnRets"
              :lengthDn="lengthDn"
              :lengthDn90="lengthDn90"
              :lengthUp="lengthUp"
              :lengthUp90="lengthUp90"
              :longTrend="longTrend"
              :mediumTrend="mediumTrend"
              :pickedTimeFrame="pickedTimeFrame"
              :renderAuxChart="renderAuxChart"
              :shortTrend="shortTrend"
              :trendsAnalyzed="trendsAnalyzed"
              :upCount="upCount"
              :upRets="upRets"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TrendsTable from "@/components/markets/TrendsTable";
import {
  colorDarkExpo,
  lightbackground2,
  dnCandles,
  colorExpo,
  colorSymmetryH,
  currencyFormat,
  darkBackgroundAlpha,
  dateFormat,
  dnCandlesAlpha2,
  formatPercent,
  formatPercentSm,
} from "@/_core/_helpers/_parametric_tools";
import { D3Chart } from "@/_core/charts/D3Chart";
import { D3HoverTrends } from "@/_core/charts/D3ChartHoverEffects";
import { lengthByDate } from "@/_core/_helpers/_helpers";
import { select } from "d3";
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "Trends",
  components: {
    QSLoading,
    TrendsTable,
  },
  props: {
    chartDataRaw: { required: true, default: () => [] },
    colorTheme: { required: true, type: Boolean, default: true },
    dataReady: { required: true },
    showLoading: { required: true },

    // ============ Data Classes ===============
    processData: { required: true },
  },
  data() {
    return {
      changeDn: 0,
      changeDn90: 0,
      changeUp: 0,
      changeUp90: 0,
      chartData: [],
      chartDataDn: [],
      chartDataUp: [],
      colorExpo: colorExpo,
      currencyFormat: currencyFormat,
      D3Chart: null,
      D3HoverTrends: null,
      dateFormat: dateFormat,
      lightbackground2: dnCandles,
      dnCount: [],
      dnRets: [],
      formatPercent: formatPercent,
      formatPercentSm: formatPercentSm,
      lengthDn: 0,
      lengthDn90: 0,
      lengthUp: 0,
      lengthUp90: 0,
      longChartDataRaw: [],
      longTrend: "",
      mediumChartDataRaw: [],
      mediumTrend: "",
      pickedDate: "10Y",
      pickedTimeFrame: "SHORT",
      renderAuxChart: 0,
      selectedDays: 1260,
      shortChartDataRaw: [],
      shortTrend: "",
      svgNode: [],
      svgNode2: [],
      screenWidth: 0,
      trendsAnalyzed: 0,
      upCount: [],
      upRets: [],
    };
  },
  created() {
    this.D3Chart = new D3Chart("trends-div", "svg-trends");
    this.D3ChartChange = new D3Chart("trends_change-div", "svg-trends_change");
    this.D3HoverTrends = new D3HoverTrends();
  },
  mounted() {
    if (this.chartDataRaw.length > 0) {
      this.selectedDays = lengthByDate(
        this.pickedDate,
        this.chartDataRaw.map((d) => d.date),
      );
      this.SMLdataPrep();
    }

    let _this = this;
    this.updateScreenWidth();
    window.addEventListener("resize", function() {
      _this.callWidth();
    });
  },
  watch: {
    colorTheme() {
      this.callWidth();
    },
    spot(val) {
      if (
        val &&
        this.shortChartDataRaw.length > 0 &&
        this.mediumChartDataRaw.length > 0 &&
        this.longChartDataRaw.length > 0
      ) {
        // === short ===
        let nLen = this.shortChartDataRaw.length - 1;
        let previousSpot = this.shortChartDataRaw[nLen]["close"];
        this.shortChartDataRaw[nLen]["close"] = val;
        this.shortChartDataRaw[nLen]["high"] = Math.max(
          val,
          this.shortChartDataRaw[nLen]["high"],
        );
        this.shortChartDataRaw[nLen]["low"] = Math.min(
          val,
          this.shortChartDataRaw[nLen]["low"],
        );
        this.shortChartDataRaw[nLen]["down_trend_change"] =
          this.shortChartDataRaw[nLen]["down_trend_change"] +
          Math.log(val / previousSpot);

        this.shortChartDataRaw[nLen]["up_trend_change"] =
          this.shortChartDataRaw[nLen]["up_trend_change"] +
          Math.log(val / previousSpot);

        // === medium ===
        nLen = this.mediumChartDataRaw.length - 1;
        this.mediumChartDataRaw[nLen]["close"] = val;
        this.mediumChartDataRaw[nLen]["high"] = Math.max(
          val,
          this.mediumChartDataRaw[nLen]["high"],
        );
        this.mediumChartDataRaw[nLen]["low"] = Math.min(
          val,
          this.mediumChartDataRaw[nLen]["low"],
        );
        this.mediumChartDataRaw[nLen]["down_trend_change"] =
          this.mediumChartDataRaw[nLen]["down_trend_change"] +
          Math.log(val / previousSpot);
        this.mediumChartDataRaw[nLen]["up_trend_change"] =
          this.mediumChartDataRaw[nLen]["up_trend_change"] +
          Math.log(val / previousSpot);

        // === long ===
        nLen = this.longChartDataRaw.length - 1;
        this.longChartDataRaw[nLen]["close"] = val;
        this.longChartDataRaw[nLen]["high"] = Math.max(
          val,
          this.longChartDataRaw[nLen]["high"],
        );
        this.longChartDataRaw[nLen]["low"] = Math.min(
          val,
          this.longChartDataRaw[nLen]["low"],
        );
        this.longChartDataRaw[nLen]["down_trend_change"] =
          this.longChartDataRaw[nLen]["down_trend_change"] +
          Math.log(val / previousSpot);
        this.longChartDataRaw[nLen]["up_trend_change"] =
          this.longChartDataRaw[nLen]["up_trend_change"] +
          Math.log(val / previousSpot);
        this.dataPrepTrends(false);
      }
    },
    dataReady() {
      this.selectedDays = lengthByDate(
        this.pickedDate,
        this.chartDataRaw.map((d) => d.date),
      );
      this.SMLdataPrep();
    },
    showLoading() {
      if (this.showLoading) {
        this.lengthUp = 0;
        this.lengthDn = 0;
        this.lengthUp90 = 0;
        this.lengthDn90 = 0;
        this.changeUp = 0;
        this.changeDn = 0;
        this.changeUp90 = 0;
        this.changeDn90 = 0;
        this.trendsAnalyzed = 0;
        this.shortTrend = "";
        this.mediumTrend = "";
        this.longTrend = "";
        select("#trends-div")
          .selectAll(".tooltip")
          .remove();
        select("#trends_change-div")
          .selectAll(".tooltip")
          .remove();
        select("#trends-div")
          .select("svg > *")
          .remove();
        select("#trends_change-div")
          .select("svg > *")
          .remove();
        select("#trend_selected-div")
          .select("svg > *")
          .remove();
      }
    },
  },
  methods: {
    SMLdataPrep() {
      this.shortChartDataRaw = this.dataPrep(this.chartDataRaw, "short");
      this.mediumChartDataRaw = this.dataPrep(this.chartDataRaw, "medium");
      this.longChartDataRaw = this.dataPrep(this.chartDataRaw, "long");
      this.dataPrepTrends();
    },
    dataPrep(data, term) {
      let newData = [],
        find_min = "",
        find_max = "",
        interp_trend = "";
      if (term === "short") {
        find_min = "find_min_short";
        find_max = "find_max_short";
        interp_trend = "interp_trend_short";
        newData = this.filterData(data, find_min, find_max, interp_trend);
        this.shortTrend = !Number.isNaN(newData[newData.length - 1].up_trend)
          ? "UP"
          : !Number.isNaN(newData[newData.length - 1].dn_trend)
          ? "DOWN"
          : "UNDEFINED ";
      } else if (term === "medium") {
        find_min = "find_min_medium";
        find_max = "find_max_medium";
        interp_trend = "interp_trend_medium";
        newData = this.filterData(data, find_min, find_max, interp_trend);
        this.mediumTrend = !Number.isNaN(newData[newData.length - 1].up_trend)
          ? "UP"
          : !Number.isNaN(newData[newData.length - 1].dn_trend)
          ? "DOWN"
          : "UNDEFINED ";
      } else if (term === "long") {
        find_min = "find_min_long";
        find_max = "find_max_long";
        interp_trend = "interp_trend_long";
        newData = this.filterData(data, find_min, find_max, interp_trend);
        this.longTrend = !Number.isNaN(newData[newData.length - 1].up_trend)
          ? "UP"
          : !Number.isNaN(newData[newData.length - 1].dn_trend)
          ? "DOWN"
          : "UNDEFINED ";
      } else {
        return null;
      }
      return newData;
    },
    filterData(data, find_min, find_max, interp_trend) {
      let newData = [];
      let len = data.length,
        uptrend = NaN,
        downtrend = NaN,
        interpChangeUp = NaN,
        interpChangeDown = NaN,
        up = NaN,
        dn = NaN,
        upCounter = 0,
        dnCounter = 0,
        upBoolean = NaN,
        dnBoolean = NaN;
      for (let i = 0; i < len; i++) {
        if (i > 0) {
          // ==
          if (data[i][find_max] != null && data[i][find_max] !== 0) {
            dnCounter = 0;
            upBoolean = 1;
          } else {
            dnCounter += 1;
            upBoolean = NaN;
          }
          if (data[i][find_min] != null && data[i][find_min] !== 0) {
            upCounter = 0;
            dnBoolean = 1;
          } else {
            upCounter += 1;
            dnBoolean = NaN;
          }
          // ==
          if (!Number.isNaN(uptrend)) {
            if (data[i - 1][find_max] != null && data[i - 1][find_max] !== 0) {
              uptrend = NaN;
              up = NaN;
              interpChangeUp = NaN;
            } else {
              uptrend = data[i].close;
              interpChangeUp = Math.log(data[i][interp_trend] / up);
            }
          } else {
            if (data[i][find_min] != null && data[i][find_min] !== 0) {
              uptrend = data[i].close;
              up = uptrend;
              interpChangeUp = Math.log(data[i][interp_trend] / up);
            } else {
              uptrend = NaN;
              up = NaN;
              interpChangeUp = NaN;
            }
          }
          if (!Number.isNaN(downtrend)) {
            if (data[i - 1][find_min] != null && data[i - 1][find_min] !== 0) {
              downtrend = NaN;
              dn = NaN;
              interpChangeDown = NaN;
            } else {
              downtrend = data[i].close;
              interpChangeDown = Math.log(data[i][interp_trend] / dn);
            }
          } else {
            if (data[i][find_max] != null && data[i][find_max] !== 0) {
              downtrend = data[i].close;
              dn = downtrend;
              interpChangeDown = Math.log(data[i][interp_trend] / dn);
            } else {
              downtrend = NaN;
              dn = NaN;
              interpChangeDown = NaN;
            }
          }
        }
        if (i === len - 1) {
          if (Number.isNaN(downtrend)) {
            upBoolean = 1;
          } else {
            dnBoolean = 1;
          }
        }
        newData.push({
          date: data[i]["date"],
          open: data[i]["open"],
          interp_trend: data[i][interp_trend],
          high: data[i]["high"],
          low: data[i]["low"],
          close: data[i]["close"],
          up_trend: uptrend,
          dn_trend: downtrend,
          interp_trend_up: interpChangeUp,
          interp_trend_dn: interpChangeDown,
          up_trend_change: Math.log(uptrend / up),
          down_trend_change: Math.log(downtrend / dn),
          ma20: data[i]["ma20"],
          ma40: data[i]["ma40"],
          upCount: upCounter * upBoolean,
          dnCount: dnCounter * dnBoolean,
          upChange: upBoolean * Math.log(uptrend / up),
          dnChange: dnBoolean * Math.log(downtrend / dn),
        });
      }
      return newData;
    },
    dataPrepTrends(statsBool = true) {
      if (this.pickedTimeFrame === "SHORT") {
        this.chartData = this.processData.toSlice(
          this.shortChartDataRaw,
          this.selectedDays,
        );
      } else if (this.pickedTimeFrame === "MEDIUM") {
        this.chartData = this.processData.toSlice(
          this.mediumChartDataRaw,
          this.selectedDays,
        );
      } else if (this.pickedTimeFrame === "LONG") {
        this.chartData = this.processData.toSlice(
          this.longChartDataRaw,
          this.selectedDays,
        );
      }
      // Uptrend statistics for selection
      if (statsBool === true) {
        this.upCount = this.chartData
          .map((d) => d.upCount / 21.75)
          .filter((d) => d != null && Number.isFinite(d) && d !== 0);
        this.lengthUp =
          Math.round(this.processData.average(this.upCount) * 10) / 10;
        this.lengthUp90 =
          Math.round(
            this.processData.percentile(
              JSON.parse(JSON.stringify(this.upCount)).sort(function(a, b) {
                return a - b;
              }),
              0.9,
            ) * 10,
          ) / 10;
        this.upRets = this.chartData
          .map((d) => d.upChange)
          .filter((d) => d != null && Number.isFinite(d) && d !== 0);
        this.changeUp = this.processData.average(this.upRets);
        this.changeUp90 = this.processData.percentile(
          JSON.parse(JSON.stringify(this.upRets)).sort(function(a, b) {
            return a - b;
          }),
          0.9,
        );

        // Downtrend statistics for selection
        this.dnCount = this.chartData
          .map((d) => d.dnCount / 21.75)
          .filter((d) => d != null && Number.isFinite(d) && d !== 0);
        this.lengthDn =
          Math.round(this.processData.average(this.dnCount) * 10) / 10;
        this.lengthDn90 =
          Math.round(
            this.processData.percentile(
              JSON.parse(JSON.stringify(this.dnCount)).sort(function(a, b) {
                return a - b;
              }),
              0.9,
            ) * 10,
          ) / 10;
        this.dnRets = this.chartData
          .map((d) => d.dnChange)
          .filter((d) => d != null && Number.isFinite(d) && d !== 0);
        this.changeDn = this.processData.average(this.dnRets);
        this.changeDn90 = this.processData.percentile(
          JSON.parse(JSON.stringify(this.dnRets)).sort(function(a, b) {
            return a - b;
          }),
          0.1,
        );
        this.trendsAnalyzed = this.upCount.length + this.dnCount.length;
      }
      this.chartDataUp = this.chartData.filter(
        (d) => !Number.isNaN(d.up_trend),
      );
      this.chartDataDn = this.chartData.filter(
        (d) => !Number.isNaN(d.dn_trend),
      );
      this.renderAuxChart += 1;
      this.createLowerChart();
      this.createUpperChart();
    },
    createUpperChart() {
      // === set SVG canvas
      this.svgNode = this.D3Chart.setSVG(
        0.5,
        5,
        0.5,
        62,
        0.5,
        30,
        0.55,
        5,
        this.colorTheme,
      );
      // === set axis
      let minMaxYAxis = this.processData.minMax(this.chartData, "high", "low");
      this.svgNode = this.D3Chart.setAxis(
        this.svgNode,
        this.chartData,
        minMaxYAxis,
        this.dateFormat,
        60,
        8,
        false,
        [],
        true,
        true,
        false,
        [],
        false,
      );
      // === line charts with area
      this.D3Chart.linesArea(
        this.svgNode,
        this.chartData,
        darkBackgroundAlpha(this.colorTheme),
        darkBackgroundAlpha(this.colorTheme),
        2,
        darkBackgroundAlpha(this.colorTheme),
        "close",
        "interp_trend",
      );
      // === MAs
      // this.D3Chart.line(this.svgNode, this.processData.mapFieldName(this.chartData, "ma20"),
      //     colorNet(this.colorTheme), 1);
      // this.D3Chart.line(this.svgNode, this.processData.mapFieldName(this.chartData, "ma40"),
      //     lightbackground2(this.colorTheme), 1);
      // === candles
      this.D3Chart.candles(
        this.svgNode,
        this.chartDataUp,
        colorExpo(this.colorTheme),
        colorDarkExpo(this.colorTheme),
        "Up",
        0.6,
        0.25,
      );
      this.D3Chart.candles(
        this.svgNode,
        this.chartDataDn,
        lightbackground2(this.colorTheme),
        lightbackground2(this.colorTheme),
        "Dn",
        0.6,
        0.25,
      );
      // === custom hover effects and info
      this.D3HoverTrends.hoverFct(
        this.svgNode,
        this.chartData,
        this.chartDataUp.map((d) => d.date),
        this.chartDataDn.map((d) => d.date),
        "TREND",
        this.dateFormat,
        this.currencyFormat,
        this.formatPercent,
        colorSymmetryH(this.colorTheme),
        dnCandles(this.colorTheme),
        this.svgNode2,
        this.colorTheme,
      );
    },
    createLowerChart() {
      // === set SVG canvas
      this.svgNode2 = this.D3ChartChange.setSVG(
        0.5,
        5,
        0.55,
        62,
        0.5,
        30,
        0.5,
        5,
        this.colorTheme,
      );
      // === set axis
      let minMaxYAxis = this.processData.minMax(
        this.chartData.filter((d) => !Number.isNaN(d.up_trend_change)),
        "up_trend_change",
        "up_trend_change",
      );
      minMaxYAxis = this.processData.minMax(
        this.chartData.filter((d) => !Number.isNaN(d.down_trend_change)),
        "down_trend_change",
        "down_trend_change",
        minMaxYAxis,
      );
      minMaxYAxis = [
        Math.min(minMaxYAxis[0], -minMaxYAxis[1]),
        Math.max(-minMaxYAxis[0], minMaxYAxis[1]),
      ];
      this.svgNode2 = this.D3ChartChange.setAxis(
        this.svgNode2,
        this.chartData,
        minMaxYAxis,
        this.dateFormat,
        60,
        5,
        false,
        [],
        true,
        true,
        true,
        this.formatPercentSm,
        false,
      );
      // === 90percentile line and area
      let upPer = this.processData.percentile(
        this.upRets.sort(function(a, b) {
          return a - b;
        }),
        0.9,
      );
      let dnPer = this.processData.percentile(
        this.dnRets.sort(function(a, b) {
          return a - b;
        }),
        0.1,
      );
      this.D3Chart.horizontalLine(
        this.svgNode2,
        dnPer,
        dnCandlesAlpha2(this.colorTheme),
        1,
        false,
        true,
        dnCandlesAlpha2(this.colorTheme),
      );
      this.D3Chart.horizontalLine(
        this.svgNode2,
        upPer,
        dnCandlesAlpha2(this.colorTheme),
        1,
        true,
        false,
        dnCandlesAlpha2(this.colorTheme),
      );
      // === line charts with area
      this.D3ChartChange.linesArea(
        this.svgNode2,
        this.chartData,
        colorExpo(this.colorTheme),
        darkBackgroundAlpha(this.colorTheme),
        2,
        darkBackgroundAlpha(this.colorTheme),
        "up_trend_change",
        "interp_trend_up",
      );
      this.D3ChartChange.linesArea(
        this.svgNode2,
        this.chartData,
        lightbackground2(this.colorTheme),
        darkBackgroundAlpha(this.colorTheme),
        2,
        darkBackgroundAlpha(this.colorTheme),
        "down_trend_change",
        "interp_trend_dn",
      );
      // === custom hover effects and info
      this.D3HoverTrends.hoverFct(
        this.svgNode2,
        this.chartData,
        this.chartDataUp.map((d) => d.date),
        this.chartDataDn.map((d) => d.date),
        "CHANGE",
        this.dateFormat,
        this.currencyFormat,
        this.formatPercent,
        colorExpo(this.colorTheme),
        lightbackground2(this.colorTheme),
        this.svgNode2,
        this.colorTheme,
      );
    },
    _pickedDate(paramInterval) {
      this.pickedDate = paramInterval;
      this.selectedDays = lengthByDate(
        this.pickedDate,
        this.chartDataRaw.map((d) => d.date),
      );
      this.dataPrepTrends();
    },
    _pickedTimeFrame(paramInterval) {
      this.pickedTimeFrame = paramInterval;
      this.dataPrepTrends();
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    callWidth() {
      this.updateScreenWidth();
      this.dataPrepTrends();
    },
  },
};
</script>

<style scoped>
.container-title-analysis {
  display: flex;
  align-items: center;
  font-size: 1rem !important;
  min-height: 23px;
}
.container-chart-trends {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
}
.container-legends-trends {
  position: absolute;
  left: 12px;
  top: 5%;
  z-index: 1000;
}
.container-legends-hist {
  top: 21%;
}
@media (min-width: 1440px) {
  .container-title-analysis {
    min-height: 40px;
  }
  .container-legends-trends {
    top: 10%;
  }
  .container-legends-hist {
    top: 20%;
  }
}
</style>
